import clsx from "clsx"
import { type ReactElement, memo } from "react"
import { Card } from "@/ui/Card"
import { type IArchiveCardList } from "./types"

export const ArchiveCardList = memo(function ArchiveCardList({
  items,
  isMatchActive,
  onClickCard
}: IArchiveCardList): ReactElement[] {
  return items.map((el, i) => {
    const index = Math.min(i, 1)

    return (
      <Card
        {...el}
        dataFlipId={`card-${el.id}`}
        className={clsx("box", el.status)}
        style={{
          transform: `translateX(-${index * 20}%) translateY(-${index * 0.5}%)`,
          zIndex: items.length - index,
          opacity: i === 0 ? 0.5 : 0
        }}
        isMatchActive={isMatchActive}
        onClick={
          onClickCard
            ? () => {
                onClickCard(el.data)
              }
            : undefined
        }
        key={`card-${el.id}`}
      >
        {el.id}
      </Card>
    )
  })
})
